import React from "react";
import { Button as MuiButton } from "@mui/material";
import { useTheme } from "../../theme/ThemeContext";

const AppButton = ({
  variant = "contained",
  size = "medium",
  children,
  color = "primary",
  sx = {},
  variantStyle,
  ...props
}) => {
  const theme = useTheme();

  const getTypographyStyle = () => {
    switch (variantStyle) {
      case "h1":
        return { fontSize: "2rem", fontWeight: 700 };
      case "h2":
        return { fontSize: "1.5rem", fontWeight: 600 };
      case "h3":
        return { fontSize: "1.25rem", fontWeight: 600 };
      case "h4":
        return { fontSize: "1rem", fontWeight: 500 };
      case "subtitle1":
        return { fontSize: "0.875rem", fontWeight: 500 };
      case "subtitle2":
        return { fontSize: "0.75rem", fontWeight: 500 };
      case "body1":
        return { fontSize: "1rem", fontWeight: 400 };
      case "body2":
        return { fontSize: "0.875rem", fontWeight: 400 };
      case "buttonLg":
        return { fontSize: "1.125rem", fontWeight: 600 };
      case "buttonSm":
        return { fontSize: "0.75rem", fontWeight: 500 };
      default:
        return {}; // fallback to MUI default styles
    }
  };

  const getButtonStyles = () => ({
    borderRadius: 2,
    boxShadow: "none",
    backgroundColor: theme?.app_button_color,
    color: theme?.app_button_text_color,
    ...getTypographyStyle(),
    "&:hover": {
      backgroundColor: theme?.app_hover_button_color,
      opacity: 0.9,
    },
    "&:disabled": {
      backgroundColor: "#cccccc",
      color: "#666666",
    },
  });

  return (
    <MuiButton
      variant={variant}
      size={size}
      sx={{
        ...getButtonStyles(),
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiButton>
  );
};

export default AppButton;
